var map = {
	"./black-normal.png": "6459",
	"./dcpthgz-normal.png": "0ec9",
	"./print-normal.png": "68d8",
	"./schgz-normal.png": "8329",
	"./wchgz-normal.png": "db10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8dfc";